import axios from 'axios'
import  { checkErrorData } from './authAction'
import  { formatList, orderByAsc, capitalize, capitalizeWord } from './format'

export function newArticle(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_ARTICLE_START", payload: "" })
            
            console.log("new Article START", {data})
            const res = await axios.post('/demands/article/new',{data})
            console.log({res});
                        
            if (checkErrorData(res, "CREATE_ARTICLE_ERROR", dispatch ) ) {
                // res.data.article_name = capitalizeWord(res.data.article_name)
				dispatch({ type: "NEW_ARTICLE", payload: res.data })
				dispatch({ type: "CREATE_ARTICLE_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] new article ", err);
            dispatch({
                type: "CREATE_ARTICLE_ERROR",
                payload: err
            })
        }
    }
}
export function newSession(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_SESSION_START", payload: "" })
            
            console.log("new Article START", {data})
            const res = await axios.post('/demands/session/new',{data})
            console.log({res});
                        
            if (checkErrorData(res, "CREATE_SESSION_ERROR", dispatch ) ) {
				dispatch({ type: "NEW_SESSION", payload: res.data })
				dispatch({ type: "CREATE_SESSION_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] new article ", err);
            dispatch({
                type: "CREATE_SESSION_ERROR",
                payload: err
            })
        }
    }
}
export function newUserDemand(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_USER_DEMAND_START", payload: "" })
            
            console.log("new USER DEMAND START", {data})
            const res = await axios.post('/demands/user/new',{data})
            console.log({res});
                        
            if (checkErrorData(res, "CREATE_USER_DEMAND_ERROR", dispatch ) ) {

				dispatch({ type: "NEW_USER_DEMAND", payload: formatList(res.data, "demand_id") })
				dispatch({ type: "CREATE_USER_DEMAND_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] new USER DEMAND ", err);
            dispatch({
                type: "CREATE_USER_DEMAND_ERROR",
                payload: err
            })
        }
    }
}

export function fetchSessions() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_SESSIONS_START", payload: "" })

            console.log("fetch Session START")
            const res = await axios.get('/demands/session/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_SESSIONS_ERROR", dispatch ) ) {               
                dispatch({
                    type: "GET_SESSIONS",
                    payload: formatList(res.data, "session_id")
                })
                dispatch({ type: "FETCH_SESSIONS_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get sessions list ", err);
            dispatch({ type: "FETCH_SESSIONS_ERROR", payload: err })
        }
    }
}
export function fetchCurrentSession() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_CURRENT_SESSION_START", payload: "" })

            console.log("fetch  current Session START")
            const res = await axios.get('/demands/session/get/current')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_CURRENT_SESSION_ERROR", dispatch ) ) {               
                dispatch({
                    type: "GET_CURRENT_SESSION",
                    payload: res.data.session_id !== "" ? [res.data] : [],
                })
                dispatch({ type: "FETCH_CURRENT_SESSION_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get sessions list ", err);
            dispatch({ type: "FETCH_CURRENT_SESSION_ERROR", payload: err })
        }
    }
}


export function fetchArticles() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_ARTICLES_START", payload: "" })

            console.log("fetch Article START")
            const res = await axios.get('/demands/article/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_ARTICLES_ERROR", dispatch ) ) {               
                dispatch({
                    type: "GET_ARTICLES",
                    payload: formatList(res.data, "article_id")
                })
                dispatch({ type: "FETCH_ARTICLES_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get articles list ", err);
            dispatch({ type: "FETCH_ARTICLES_ERROR", payload: err })
        }
    }
}
export function fetchAllDemands() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_USER_DEMANDS_START", payload: "" })

            console.log("fetch AllDemand START")
            const res = await axios.get('/demands/line/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_USER_DEMANDS_ERROR", dispatch ) ) {               
                dispatch({
                    type: "GET_USER_DEMANDS",
                    payload: formatList(res.data, "demand_id")
                })
                dispatch({ type: "FETCH_USER_DEMANDS_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get demands list ", err);
            dispatch({ type: "FETCH_USER_DEMANDS_ERROR", payload: err })
        }
    }
}
export function fetchUserDemands() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_USER_DEMANDS_START", payload: "" })

            console.log("fetch UserDemand START")
            const res = await axios.get('/demands/user/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_USER_DEMANDS_ERROR", dispatch ) ) {               
                dispatch({
                    type: "GET_USER_DEMANDS",
                    payload: formatList(res.data, "demand_id")
                })
                dispatch({ type: "FETCH_USER_DEMANDS_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get demands list ", err);
            dispatch({ type: "FETCH_USER_DEMANDS_ERROR", payload: err })
        }
    }
}

export function updateArticle(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_ARTICLE_START", payload: "" })

            console.log("update Article START")
            const res = await axios.post("/demands/article/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_ARTICLE_ERROR", dispatch ) ) {               
                // data.article_name = capitalizeWord(data.article_name)
				dispatch({
                    type: "UPDATE_ARTICLE",
                    payload: data
                })
				dispatch({ type: "UPDATE_ARTICLE_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update article ", err);
            dispatch({
                type: "UPDATE_ARTICLE_ERROR",
                payload: err
                
            })
        }
    }
}
export function updateSession(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_SESSION_START", payload: "" })

            console.log("update session START")
            const res = await axios.post("/demands/session/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_SESSION_ERROR", dispatch ) ) {               
				dispatch({
                    type: "UPDATE_SESSION",
                    payload: data
                })
				dispatch({ type: "UPDATE_SESSION_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update article ", err);
            dispatch({
                type: "UPDATE_SESSION_ERROR",
                payload: err
                
            })
        }
    }
}
export function updateSessionStatus(session_id, op_type) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_SESSION_START", payload: "" })

            console.log("update session START")
            const res = await axios.post("/demands/session/status/update", {session_id, op_type})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_SESSION_ERROR", dispatch ) ) {               
				dispatch({
                    type: "UPDATE_SESSION",
                    payload: res.data
                })
				dispatch({ type: "UPDATE_SESSION_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update session ", err);
            dispatch({
                type: "UPDATE_SESSION_ERROR",
                payload: err
                
            })
        }
    }
}
export function updateUserDemand(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_USER_DEMAND_START", payload: "" })

            console.log("update Article START")
            const res = await axios.post("/demands/user/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_USER_DEMAND_ERROR", dispatch ) ) {               
                data.article_name = capitalizeWord(data.article_name)
				dispatch({
                    type: "UPDATE_USER_DEMAND",
                    payload: data
                })
				dispatch({ type: "UPDATE_USER_DEMAND_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update article ", err);
            dispatch({
                type: "UPDATE_USER_DEMAND_ERROR",
                payload: err
                
            })
        }
    }
}
export function updateArticlePics(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_ARTICLE_START", payload: "" })

            console.log("update Article START")
            const res = await axios.post("/demands/articles/pics/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_ARTICLE_ERROR", dispatch ) ) {               
                // data.article_name = capitalizeWord(data.article_name)
				dispatch({
                    type: "UPDATE_ARTICLE",
                    payload: res.data
                })
				dispatch({ type: "UPDATE_ARTICLE_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update article ", err);
            dispatch({
                type: "UPDATE_ARTICLE_ERROR",
                payload: err
                
            })
        }
    }
}
